<script setup>
import { ref } from 'vue'
// import { getHeadLineBanner } from '@/api/2023/index.js'
// import { CloseOutlined } from '@ant-design/icons-vue'
const openMenu = ref(false) // 打开菜单
const current = ref('')
// const bannerData = ref({})
// const isShowBanner = ref(false)
const menu = [
  {
    key: 'about',
    title: '关于大会',
    herf: '#about'
  },
  {
    key: 'active',
    title: '最新活动',
    herf: '#active'
  },
  {
    key: 'news',
    title: '新闻中心',
    herf: '#news'
  },
  {
    key: 'review',
    title: '往届回顾',
    herf: '#review'
  }
]
// onMounted(() => {
//   fetchBanner()
//   setTimeout(() => {
//     closeBanner()
//   }, 15000)
// })

// function closeBanner() {
//   isShowBanner.value = false
// }

// function toJump(link) {
//   if (link) {
//     window.open(link, '_blank')
//   }
// }
// function fetchBanner() {
//   getHeadLineBanner()
//     .then((res) => {
//       console.log('res', res.data)
//       const { data } = res.data
//       if (Object.keys(data).length) {
//         bannerData.value = data
//         isShowBanner.value = true
//       }
//       return
//     })
//     .catch((err) => {
//       console.log('err', err)
//     })
// }

function toOpen() {
  openMenu.value = !openMenu.value
}
function pitchKey(newKey) {
  current.value = newKey
  openMenu.value = !openMenu.value
}
</script>
<template>
  <div class="header">
    <img class="headerLogo" src="https://p4.ssl.qhimg.com/t01b5a1bb5fed76f084.png" alt="logo" />
    <img
      v-if="!openMenu"
      class="headerMore"
      src="https://p1.ssl.qhimg.com/t01d6cba9fec2b6af66.png"
      alt="打开"
      @click="toOpen"
    />
    <img
      v-else
      class="headerMore"
      src="https://p2.ssl.qhimg.com/t0163dd12ed68d8f25c.png"
      alt="关闭"
      @click="toOpen"
    />
  </div>
  <ul v-if="openMenu" class="menu">
    <li v-for="item in menu" :key="item.key" class="menuList" @click="pitchKey(item.key)">
      <a :href="item.herf" :class="[current === item.key ? 'pitch' : '']"> {{ item.title }}</a>
    </li>
  </ul>
  <!-- <div v-if="isShowBanner" class="banner">
    <img :src="bannerData.img_h5" :alt="bannerData.company" @click="toJump(bannerData.url)" />
    <div class="bannerClose" @click="closeBanner()">
      <close-outlined />
    </div>
  </div> -->
</template>
<style lang="scss" scoped>
.header {
  position: fixed;
  top: 0;
  z-index: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100vw;
  // min-width: 414px;
  height: 48px;
  background: #006853;
  padding: 11px 14px 11px 16px;
  &Logo {
    width: 102px;
    margin-right: 24px;
  }
  &More {
    width: 18px;
    height: 18px;
  }
}
.menu {
  position: fixed;
  top: 48px;
  z-index: 999;
  padding: 0 24px;
  width: 100vw;
  background: rgba(0, 0, 0, 0.8);

  &List {
    list-style: none;
    font-size: 14px;
    padding: 16px 0 15px 0;
    border-bottom: 1px solid rgba(216, 216, 216, 0.4);
    a {
      color: #ffffff;
    }
    &:last-child {
      border: 0;
    }
  }
}
.pitch {
  color: #00ab7a !important;
}
.banner {
  position: fixed;
  bottom: 0px;
  width: 100%;
  height: 150px;
  z-index: 10;
  background-color: #fff;
  cursor: pointer;
  img {
    width: 100%;
    height: 100%;
  }
  &Close {
    position: absolute;
    right: 15px;
    top: 15px;
    color: #999999;
  }
}
</style>
